import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
    addArea,
    getAreaById,
  updateArea,
  updateColor,
} from "../../../actions/homeAction";

const AddEditArea = () => {
    const params = useParams()
    const singleColor = useSelector((state) => state.home.areaID)?.response;
    const [color, setColor] = useState({
        name: "",
        priority: "",
        status: "true",
      });
    
      const [dataEdit, setDataEdit] = useState(false);
      const { clUUID } = useParams();
    
      const dispatch = useDispatch();
    
      useEffect(() => {
        if(params.area_id){
            dispatch(getAreaById(params?.area_id));
        }
      }, [params]);

      useEffect(()=>{
        if(singleColor){
            setColor({
                name: singleColor?.name,
                priority: singleColor?.priority,
                status: singleColor?.status===1?"true":"false",
            })
        }
      },[singleColor])
    
      const data = singleColor;
    
     
    
      console.log("singleColor", singleColor);
      const onChangeHandle = (e) => {
        const { name, value } = e.target;
        setColor({ ...color, [name]: value });
      };
    
      const onSave = () => {
        if (params?.area_id) {
          const payload = {
            name: color.name,
            priority: parseInt(color.priority),
            status: color.status==="true"?true:false,
            countryId: data.countryId,
          };
          console.log("payload",payload);
          
          dispatch(updateArea(payload));
        } else {
            const add = {
                name: color.name,
                priority: parseInt(color.priority),
              };
          dispatch(addArea(add));
        }
      };
  return (
    <div className="main-body">
    <div className="page-wrapper">
      <div className="page-header">
        <div className="row align-items-end">
          <div className="col-lg-8">
            <div className="page-header-title">
              <div className="d-inline">
                <h4>{dataEdit ? `Edit : ${data?.Area}` : "Add Area"}</h4>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="page-header-breadcrumb">
              <ul className="breadcrumb-title">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="feather icon-home"></i>{" "}
                  </Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/area">Area</Link>
                </li>
                <li className="breadcrumb-item active">
                  {dataEdit ? "Edit Area:" : "Add Area"}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="row">
          <div className="col-sm-12">
            <div className="card card-border-default">
              <div className="card-block">
                <div className="tab-content tabs">
                  <div
                    className="tab-pane  active"
                    id={"car_user_"}
                    role="tabpanel"
                    aria-labelledby=""
                  >
                    <div className="">
                      <div className="col-md-6"></div>

                      {/* sdjkfj */}
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Name
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="name"
                                  value={color.name}
                                  placeholder="Name"
                                  onChange={onChangeHandle}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                               Priority
                              </label>
                              <div className="col-sm-9">
                                <input
                                  type="number"
                                  className="form-control"
                                  name="priority"
                                  value={color.priority}
                                  placeholder="Priority"
                                  onChange={onChangeHandle}
                                />
                              </div>
                            </div>
                          </div>

                          {params?.area_id? <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">
                                Status
                              </label>
                              <div className="col-sm-9">
                                <select
                                  name="status"
                                  className="form-control"
                                  onChange={onChangeHandle}
                                  value={color?.status}
                                >
                                  <option value={true} name="active">
                                    Active
                                  </option>
                                  <option value={false} name="inactive">
                                    Inactive
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div> :''}
                        </div>
                        <div className="card-footer">
                          <div className="row float-right p-3">
                            <button
                              onClick={onSave}
                              className="btn btn-grd-disabled mr-2"
                            >
                              <i className="icofont icofont-save"></i>
                              {dataEdit ? "Update" : "Add"}
                            </button>
                            <Link
                              to={"/area"}
                              className="btn btn-outline-dark"
                            >
                              {" "}
                              Cancel{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default AddEditArea